export const appDownloadIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="currentColor" d="M17 9.647h-3.714V4H7.714v5.647H4l6.5 6.588L17 9.647zm-13 8.47V20h13v-1.882H4z"/></g></svg>`,
    name: 'download' as const
};